import React, {useEffect} from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {ButtonVariant} from 'components/ui-kit/Button';
import {Drawer} from 'components/ui-kit/Sidebar';
import {DrawerCloseButton} from 'components/ui-kit/Sidebar/close-button';
import {doLogout} from 'models/auth';
import {closeSidebar, isSidebarOpened$} from 'models/mobileSidebar';
import {breakpoint} from 'theme';
import {useMatchMedia} from 'utils/custom-hooks';

import {Logo} from '../Logo';
import {SidebarNavigation} from '../Navigation';

import {Language, LogoContainer, LogoutButton, SidebarContent, SidebarHeader} from './styled';

export function MobileSidebar() {
    const {t} = useTranslation();
    const isOpen = useStore(isSidebarOpened$);

    const isMobile = useMatchMedia(`(max-width: ${breakpoint.desktop})`);

    useEffect(() => {
        if (!isMobile) {
            closeSidebar();
        }
    }, [isMobile]);

    return (
        <Drawer open={isOpen} onClose={() => closeSidebar()}>
            <SidebarContent>
                <SidebarHeader>
                    <LogoContainer>
                        <DrawerCloseButton onClick={() => closeSidebar()} />
                        <Logo />
                    </LogoContainer>
                    {/* System Search temporary disabled (MAR-348) */}
                    {/*<Search>*/}
                    {/*    <Input placeholder={`${t('components.header.Search')}...`} />*/}
                    {/*</Search>*/}
                    <Language />
                </SidebarHeader>
                <SidebarNavigation isMobile={true} onClickHandler={() => closeSidebar()} />
                <LogoutButton onClick={() => doLogout(true)} variant={ButtonVariant.Text}>
                    {t('components.header.Exit')}
                </LogoutButton>
            </SidebarContent>
        </Drawer>
    );
}
